export default __webpack_public_path__ + "static/media/raccoon.b65b02b3.png";